import * as yup from 'yup';
import { UseFormProps } from 'react-hook-form';

import { reDate } from '@shared/lib/regex';
import { yupResolver } from '@hookform/resolvers/yup';
import { isValidDate } from '@modules/employees/shared/helpers';
import { IPersonalDetailsBase } from '@entities/employee';
import {
  INVALID_DATE_FORMAT,
  MIN_AGE_CONSTRAINT,
  REQUIRED_FIRST_NAME,
  REQUIRED_LAST_NAME,
} from '@modules/employees/shared/constants/form-error.constants';

export type FormDataType = Omit<IPersonalDetailsBase, 'fullName'>;

const schema: yup.ObjectSchema<FormDataType> = yup
  .object()
  .shape({
    firstName: yup.string().required(REQUIRED_FIRST_NAME),
    lastName: yup.string().required(REQUIRED_LAST_NAME),
    fullNameUa: yup.string().default(''),
    birthDate: yup
      .string()
      .matches(reDate, {
        excludeEmptyString: true,
        message: INVALID_DATE_FORMAT,
      })
      .test('dateOfBirth', MIN_AGE_CONSTRAINT, value =>
        isValidDate(value, {
          isYearValidation: true,
        })
      )
      .default(''),
  })
  .required();

export const setup = (defaultValues: FormDataType) => {
  const options: UseFormProps<FormDataType> = {
    defaultValues,
    resolver: yupResolver<FormDataType>(schema),
  };

  return {
    options,
  };
};
